import type { RecommendedContentType } from '../../models'
import { AdviceCard } from './AdviceCard'

type RecommendationCardProps = {
  recommendation: RecommendedContentType
  whichId: string
  modelId: string
  index: number
  large: boolean
  sectionTitle: string
}

export const RecommendationCard = ({
  recommendation,
  whichId,
  modelId,
  index,
  large,
  sectionTitle,
}: RecommendationCardProps) => {
  if (recommendation.__typename === 'RecommendedArticle') {
    const { title, subheading, href, image, id } = recommendation

    return (
      <AdviceCard
        title={title}
        subheading={subheading}
        primaryLink={href}
        imgObj={{
          imageAlt: title,
          str: image,
        }}
        ariaLabel={`${title} advice card`}
        large={large}
        trackingData={{
          'data-which-id': whichId,
          'data-section': sectionTitle,
          'data-card-name': title,
          'data-index': (index + 1).toString(),
          'data-content-id': id,
          'data-model-id': modelId,
          'data-personalisation': 'true',
        }}
      />
    )
  }

  return null
}
